module.exports = __webpack_public_path__ + "media/images/womans-well-being-template-f8143c995656706cf9dad4d6e7057cc7.jpg";